export const LANDING_PREVIEW_DEVICES = Object.freeze({
  desktop: Object.freeze({
    id: "desktop",
    label: "Escritorio",
    width: 1280,
    breakpoint: "lg",
  }),
  tablet: Object.freeze({
    id: "tablet",
    label: "Tablet",
    width: 768,
    breakpoint: "sm",
  }),
  mobile: Object.freeze({
    id: "mobile",
    label: "Celular",
    width: 390,
    breakpoint: "xs",
  }),
});

const RESPONSIVE_PRIORITY = Object.freeze({
  desktop: ["lg", "md", "sm", "xs"],
  tablet: ["sm", "xs"],
  mobile: ["xs"],
});

export function normalizeLandingPreviewDevice(value) {
  const key = String(value || "").trim().toLowerCase();
  return LANDING_PREVIEW_DEVICES[key] ? key : "desktop";
}

export function getLandingPreviewDevice(value) {
  return LANDING_PREVIEW_DEVICES[normalizeLandingPreviewDevice(value)];
}

export function resolveLandingPreviewResponsiveValue(device, values, fallback) {
  if (values === null || values === undefined || typeof values !== "object" || Array.isArray(values)) {
    return values === undefined ? fallback : values;
  }

  const normalized = normalizeLandingPreviewDevice(device);
  const priority = RESPONSIVE_PRIORITY[normalized] || RESPONSIVE_PRIORITY.desktop;
  for (const breakpoint of priority) {
    if (Object.prototype.hasOwnProperty.call(values, breakpoint)) return values[breakpoint];
  }

  return fallback;
}
